const httpErrors = {};

export function getHttpError({ status }) {
  if (!Object.prototype.hasOwnProperty.call(httpErrors, status)) {
    httpErrors[status] = class extends Error {};
  }
  return httpErrors[status];
}

export function fetchError({ error }) {
  if (!(error instanceof Error)) {
    error = new Error(error);
  }
  return error;
}

export function apiStatusError({ response }) {
  if (!response.ok) {
    const HttpStatusError = getHttpError({ status: response.status });
    console.error(`API ERROR: ${response.message ?? response.statusText}`);
    throw new HttpStatusError(response.status);
  }
}
